import {svgIconWrapper} from '../svg-icon-wrapper';

import PersonSearchRegular from './person-search-regular-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    return <PersonSearchRegular {...props} />;
}
SvgComponent.iconName = 'personSearchRegular';

export const PersonSearchRegularIcon = svgIconWrapper(SvgComponent);
